const DirectionUpIcon = (props) => (
	<svg 
		xmlns="http://www.w3.org/2000/svg" 
		width="14" height="14" viewBox="0 0 14 14"
		fill="none" stroke="currentColor"
		{...props} 
	>
		<path d="M7 10L7 4M7 4L11 8M7 4L3 8" strokeWidth="2"/>
	</svg>
)

export default DirectionUpIcon